import Terms, { TermsComponent } from './terms'

import Disclosure from './Disclosure'

export { Terms, TermsComponent, Disclosure }
export default { Terms, TermsComponent, Disclosure }
